import React from "react";
import Provenance from "../Provenance";

function Description() {
  return (
    <>
      <section className="py-10 grid gap-x-16 gap-y-8 md:grid-cols-2">
        {/* Left Side Div */}
        <div className="flex flex-col gap-y-8 md:gap-y-16">
          <div>
            <h2 className="text-2xl font-semibold border-b border-[#e6e6e6] pb-5 mb-5">
              Description
            </h2>
            <div className="max-w-lg">
              <p className="break-words mb-5">
                MOCHI consists of 50 unique NFTs using expired polaroid film and
                digital manipulation to bend the raw reality of STILLZ' unique
                physical works. These artworks explore the conversation between
                authenticity, unreachable alterations in physical beauty and
                collectible merchandising. The polaroids used have been exposed
                between the timeline of 2017-2021.
              </p>
              <p>1/1</p>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-semibold border-b border-[#e6e6e6] pb-5 mb-5">
              Details
            </h2>
            <div className="grid gap-4">
              <a
                href="#"
                className="text-[#666666] hover:text-[#000] inline-flex gap-2 font-semibold no-underline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M4.364 9.999a.89.89 0 0 1 .895-.89l1.482.004a.891.891 0 0 1 .891.892v5.607c.167-.05.381-.102.616-.157a.743.743 0 0 0 .572-.723V7.776a.892.892 0 0 1 .892-.892h1.485a.891.891 0 0 1 .891.892v6.456s.372-.15.734-.304a.744.744 0 0 0 .454-.685V5.547a.891.891 0 0 1 .892-.891h1.485a.891.891 0 0 1 .891.891v6.337c1.288-.933 2.593-2.056 3.628-3.406A1.496 1.496 0 0 0 20.4 7.08 10.483 10.483 0 0 0 10.632 0C4.811-.077 0 4.677 0 10.501a10.47 10.47 0 0 0 1.394 5.252 1.327 1.327 0 0 0 1.266.656c.28-.024.63-.06 1.046-.108a.742.742 0 0 0 .659-.737V9.999M4.332 18.991a10.493 10.493 0 0 0 16.641-9.21c-3.834 5.721-10.915 8.396-16.64 9.21"></path>
                </svg>
                <p>View on Etherscan</p>
              </a>

              <a
                href="#"
                className="text-[#666666] hover:text-[#000] inline-flex gap-2 font-semibold no-underline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="h-6 w-6"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.21 5.222 10.639.936a1.428 1.428 0 0 0-1.279 0L.789 5.222A1.431 1.431 0 0 0 0 6.5v10c0 .54.306 1.035.79 1.278l8.571 4.286a1.43 1.43 0 0 0 1.278 0l8.571-4.286A1.43 1.43 0 0 0 20 16.5v-10a1.43 1.43 0 0 0-.79-1.278ZM10 3.812 15.377 6.5 10 9.189 4.623 6.501 10 3.81Zm-7.143 5 5.714 2.857v6.806l-5.714-2.857V8.812Zm8.572 9.663v-6.806l5.714-2.857v6.806l-5.714 2.857Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <p>View metadata</p>
              </a>

              <a
                href="#"
                className="text-[#666666] hover:text-[#000] inline-flex gap-2 font-semibold no-underline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>

                <p>View on IPFS</p>
              </a>
            </div>
          </div>
        </div>

        {/* Right Side Div */}
        <div>
          <h2 className="text-2xl font-semibold border-b border-[#e6e6e6] pb-5 mb-5">
            Provenance
          </h2>
          <Provenance />
          <Provenance />
        </div>
      </section>
    </>
  );
}

export default Description;
